module.exports = __webpack_public_path__ + "img/holiday-pic1.60436a87.png";